export default __webpack_public_path__ + "static/media/ReactNative.ef50a07b.svg";